/* tslint:disable:object-literal-shorthand */
import {MortgageContract, MortgageMonth} from '../../state/AppState';
import {Lazy} from '../utils/lazy';
import {lazyRnd} from '../utils/math';
import {Dynamiclist} from './dynamiclist';

export function linearZeroMonth(contract: MortgageContract): MortgageMonth {
  return {
    month: 0,
    newPrincipalPayment: 0,
    newInterestPayment: 0,
    currentTotalPrincipalPayment: 0,
    currentTotalInterestPayment: 0,
    currentTotalPremiumPayment: 0,
    currentRemainder: contract.mortgagedAmount,
    contract: contract,
    newPremiumPayment: 0
  } as MortgageMonth;
}

export function linearNextMonth(current: MortgageMonth, newPrincipal: Lazy<number>): MortgageMonth {
  const currentRemainder = () => current.currentRemainder - newPrincipal();
  const newInterest = () => current.currentRemainder * current.contract.interestRate / 100 / 12;

  return {
    ...current,
    month: current.month + 1,
    currentRemainder: lazyRnd(currentRemainder)(),
    newPrincipalPayment: lazyRnd(newPrincipal)(),
    newInterestPayment: newInterest(),
    currentTotalPrincipalPayment: lazyRnd(() => current.currentTotalPrincipalPayment + newPrincipal())(),
    currentTotalInterestPayment: lazyRnd(() => current.currentTotalInterestPayment + newInterest())(),
  };
}

export function calculatePrincipal(remainingMortgage: number, durationMonths: number): number {
  return remainingMortgage / durationMonths;
}

export function calculateDurationInMonths(mortgagedAmount: number, principal: number): number {
  return Math.ceil(mortgagedAmount / principal);
}

// Note: when payment is made, the principal will go down
export function calculateChain(currentMonth: MortgageMonth, duration: number): Dynamiclist<MortgageMonth> {
  return () => {
    if (duration < 0) {
      return null;
    } else {
      return {
        head: () => currentMonth,
        tail: (head: MortgageMonth = currentMonth) => {
          const principal = () => calculatePrincipal(head.currentRemainder, duration);
          const nextMonth = linearNextMonth(head, principal);
          return calculateChain(nextMonth, duration - 1)();
        }
      };
    }
  };
}
